const Priority = {
    HIGH_PRIORITY : "HIGH PRIORITY",
    MEDIUM_PRIORITY : "MEDIUM PRIORITY",
    LOW_PRIORITY : "LOW PRIORITY",
}

const chipList = [
    {
        id : Priority.HIGH_PRIORITY,
        title : "HIGH PRIORITY",
        priority: "HP",
        color : "#FF2473",
    },
    {
        id : Priority.MEDIUM_PRIORITY,
        title : "MEDIUM PRIORITY",
        priority : "MP",
        color : "#18B0FF",
    },
    {
        id : Priority.LOW_PRIORITY,
        title : "LOW PRIORITY",
        priority : "LP",
        color : "#63C05B",
    },
]

export {chipList}
